
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
import textTraderTitle from '~/components/textTrader/_title.vue'

export default {
  components: {
    'text-title': textTraderTitle
  },
  inject: ['info'],
  data() {
    return {
      showall: false,
      showArrow: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    bus.$on('TextTraderArrow', (sa) => {
      if (sa && (sa.pos == 'kehu' || sa.pos == 'all') && sa.show) {
        this.showArrow = true
      } else {
        this.showArrow = false
      }
    })
    console.log('客户服务')
  },
  methods: {
    show(mark) {
      this.showall = mark
    },
    DealTraderName(content, type) {
      if (!content) {
        return ''
      }
      let ret = content
      if (type == 'text') {
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      } else {
        ret = ret.replace('{brokers name}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{brokers name}/g, this.info.shortName)
        ret = ret.replace('{0}', `<a class="trader" href="${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${this.info.traderCode}.html" target="_blank">${this.info.shortName}</a>`)
        ret = ret.replace(/\{0}/g, this.info.shortName)
      }
      return ret
    },
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
